/* eslint-disable */
import React, { Component } from 'react';
import language from '../../../assets/languages/language';
import Loader from '../../../common/loader';
import ModalComponent from '../../Common/Modal';
import VideoValidateReportIcons from '../../Common/VideoValidateReportIcons';
import AppRoutes from '../../config/AppRoutes';
import alertMessage from '../../config/alertMessage';
import Report from '../Report';
import { getFavVideoById, getVideosByChapter, mutateSaveVideo, deleteFavVideo } from '../services';
import FlashCard from '../../../components/FlashCard';
import { showInformation } from '../../../common/toast';
import { messages } from '../../../common/messages';
const styles_css = { marginBottom: '20px' };

export default class ChapterVideos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [],
      showFreePremium: true,
      isLoading: true,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      notesCSS: 'fa fa-book mark-action-btn',
      questionsCSS: 'fa fa-question-circle-o mark-action-btn',
      saveVideo_text: `${language.LC().SAVE_VIDEO}`,
      showReportSection: false,
      isFlashCardHidden: true,
    };
    this.childRef = null;
    this.setChildRef = element => {
      this.childRef = element;
    };
  }

  static contextTypes = { router: React.PropTypes.object };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getVideoById();
  }

  getVideoById = async () => {
    try {
      const { chapter, index } = this.props.params;
      const response = await getVideosByChapter({ chapterID: chapter });
      if (response.success) {
        this.getFavVideo(response.data);
        this.setState({
          videos: response.data,
          showFreePremium: !Object.keys(response.userSubscriptionDetails).length,
          isLoading: false,
          currentVideoId: response.data[index].id,
        });
      }
    } catch (error) {}
  };

  moveToPracticeQuestions = async () => {
    const { chapter } = this.props.params;
    this.context.router.push({
      pathname: AppRoutes.ESG_QUESTION_BANK_LIST_QUE.replace(':listId', chapter),
    });
  };
  moveToNotes = async () => {
    this.context.router.push({ pathname: AppRoutes.ESG_NOTES });
  };

  setBookmarkColor = async (api = () => {}, id = 0) => {
    const response = await api({ video_id: id });
    if (response.success) {
      this.setState({
        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
        bookmarkColor: 'rgb(54, 141, 84)',
        saveVideo_text: `${language.LC().Video_Saved}`,
        isFlashCardHidden: false,
      });
    } else {
      this.setState({
        bookmarkColor: '',
        saveVideo_text: `${language.LC().SAVE_VIDEO}`,
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
        isFlashCardHidden: true,
      });
    }
  };

  getFavVideo = async videos => {
    const { index } = this.props.params;
    this.setBookmarkColor(getFavVideoById, videos[index].id);
    this.setState({
      currentVideoId: videos[index].id,
    });
  };

  saveFavVideo = async () => {
    const { videos } = this.state;
    const { index } = this.props.params;
    if (this.state.bookmarkCSS !== 'fa fa-bookmark mark-action-btn-bookmark') {
      this.setBookmarkColor(mutateSaveVideo, videos[index].id);
    } else {
      if (this.childRef) {
        this.childRef.deleteFlash();
      }
      const response = await deleteFavVideo({ video_id: videos[index].id });
      if (response.success) {
        this.setState({
          bookmarkColor: '',
          saveVideo_text: `${language.LC().SAVE_VIDEO}`,
          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          isFlashCardHidden: true,
        });
      }
    }
  };
  displayReportForm = async () => {
    this.setState({ showReportSection: true });
  };

  viewPdf = (pdf) => {
    const { showFreePremium } = this.state;
    if (showFreePremium) {
      this.toggleAlert();
      return;
    }
    if (pdf) {
      const myWindow = window.open(pdf);
      myWindow.focus();
    } else {
      showInformation(messages.PDF_NOT_AVAILABLE);
    }
  };

  toggleAlert = () => {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  };

  goPremium = () => {
    this.context.router.push({
      pathname: AppRoutes.SUBSCRIBE,
    });
  };

  navigateToVideoByID = async index => {
    const { chapter } = this.props.params;
    const { videos } = this.state;

    await this.context.router.push({
      pathname: AppRoutes.ESG_VIDEO_LESSON.replace(':chapter', chapter).replace(':index', index),
    });
    this.getFavVideo(videos);
  };
  render() {
    const {
      videos,
      showFreePremium,
      isLoading,
      notesCSS,
      bookmarkColor,
      bookmarkCSS,
      questionsCSS,
      saveVideo_text,
      showReportSection,
      isFlashCardHidden,
      currentVideoId,
    } = this.state;
    const { index } = this.props.params;
    let { title = 'Title', youtubeID = '', url_id_qq } = {};
    if (videos[index]) ({ title = 'Title', url_id: youtubeID, url_id_qq } = videos[index]);
    return (
      <div>
        {isLoading ? (
          <Loader />
        ) : (
          <div className='video_outer'>
            <div className='row'>
              <div className='col-xs-12 col-sm-8 col-md-8'>
                <h5 className='mb-0'>{title}</h5>
              </div>
              <div className='col-xs-12 col-sm-4 col-md-4' style={styles_css}>
                <div className='float-right text-right'>
                  {parseInt(index, 10) === 0 ? null : (
                    <i
                      className='fa fa-angle-left ques_arrow pointer_class'
                      onClick={() => this.navigateToVideoByID(parseInt(index, 10) - 1)}
                    />
                  )}
                  {parseInt(index, 10) === videos.length - 1 ? null : (
                    <i
                      className='fa fa-angle-right ques_arrow pointer_class'
                      onClick={() => this.navigateToVideoByID(parseInt(index, 10) + 1)}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className='row videos-main-wraper p-0'>
              <div className='col-xs-12 col-sm-9 col-md-9 video-show-section'>
                <div className='' id='video-height'>
                  <div className='embed-responsive embed-responsive-16by9'>
                    {url_id_qq ? (
                      <iframe
                        width='100%'
                        allowFullScreen='1'
                        height='100%'
                        position='absolute'
                        top='10'
                        left='0'
                        src={`//ljsp.lwcdn.com/api/video/embed.jsp?id=${url_id_qq}&pi=080de783-b4bf-4b42-ac09-e782c8a907ef`}
                        sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
                        frameBorder='0'
                        title='0'
                        byline='0'
                        portrait='0'
                        frameborder='10'
                      />
                    ) : (
                      <iframe
                        className='embed-responsive-item'
                        width={'100%'}
                        height={'100%'}
                        title={'video'}
                        frameBorder='0'
                        src={`https://www.youtube.com/embed/${youtubeID}?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 `}
                        allowFullScreen
                        sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className='col-xs-12 col-sm-3 col-md-3 video-tag-heading' id='video-tag-list'>
                <div className='link_list_wrap'>
                  {videos.map((item, index) => (
                    <div key={item.id}>
                      <div className='full-width' key={item.id}>
                        <div className='videotitle' key={item.id} value={item.id}>
                          {showFreePremium ? (
                            item.free ? (
                              <div className='video-type-free'>{language.LC().FREE}</div>
                            ) : (
                              <div className='video-type-primum'>{language.LC().PREMIUM}</div>
                            )
                          ) : (
                            <div />
                          )}
                          <button
                            type='button'
                            name='videourl'
                            id={item.id}
                            className={item.url_id === youtubeID ? 'active' : ''}
                            onClick={() => {
                              if (showFreePremium && !item.free) return this.toggleAlert();
                              this.navigateToVideoByID(index);
                            }}
                            value={item.url}
                          >
                            <i className='fa fa-play-circle' />
                            <div className='text-overflow'>{item.title}</div>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
        <br /> <br />
        <VideoValidateReportIcons
          moveToNotes={this.moveToNotes}
          notesCSS={notesCSS}
          moveToPracticeQuestions={this.moveToPracticeQuestions}
          _saveFavVideo={this.saveFavVideo}
          _displayReportForm={this.displayReportForm}
          viewPdf={this.viewPdf}
          bookmarkCSS={bookmarkCSS}
          bookmarkColor={bookmarkColor}
          questionsCSS={questionsCSS}
          saveVideo_text={saveVideo_text}
          video={videos[0]}
          showFreePremium={showFreePremium}
        />
        <FlashCard
          item={{ id: currentVideoId }}
          type='video'
          isFlashCardHidden={isFlashCardHidden}
          ref={this.setChildRef}
          exam='esg'
        />
        {showReportSection && (
          <Report
            hideReportSection={() => {
              this.setState({ showReportSection: false });
            }}
            section='video'
            commentOnWhichId={videos.length && videos[index].id}
          />
        )}
        <div>
          <ModalComponent
            goPremium={this.goPremium.bind(this)}
            toggleAlert={this.toggleAlert.bind(this)}
            alert_status={this.state.alert_status}
            MessageContent={alertMessage.messageContent_ESG}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/Videos/ChapterVideos.jsx